import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBuildingHouseLineFilter } from 'shared/selectors/advancedFilters';
import { EHouseLineType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const BuildingHouseLineContainer: FC = () => {
  const { label, value, options } = useSelector(selectBuildingHouseLineFilter);

  const onChange = useFilterChangeCallback();

  const handleBuildingHouseLineChange = useCallback(
    (newValue: NonEmptyArray<EHouseLineType> | null) => {
      onChange({ action: 'setBuildingHouseLine', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleBuildingHouseLineChange} />
    </AdvancedFilterRow>
  );
};
